import { TextSkeleton } from '@/components/skeletons';

// Placeholders while the profile loads, in the same pulsing-grey style as the
// shared skeletons (components/skeletons).

const Bar = ({ className }) => (
  <span className={`block animate-pulse rounded-xl bg-zinc-200 ${className}`} />
);

export function HeaderSkeleton() {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <span className="h-11 w-11 shrink-0 animate-pulse rounded-full bg-white/40" />
      <div className="grid gap-1.5">
        <TextSkeleton className="[&>span]:bg-white/40" />
        <span className="block h-3 w-56 animate-pulse rounded-xl bg-white/30" />
      </div>
    </div>
  );
}

export function TilesSkeleton() {
  const groups = [2, 5, 2, 3];
  return (
    <div className="grid min-h-0 grid-cols-2 content-start gap-2 overflow-hidden rounded-[14px] bg-white px-3 pb-3 pt-1.5">
      {groups.map((count, g) => (
        <div key={g} className="contents">
          <Bar className="col-span-2 mt-2 h-2.5 w-24" />
          {Array.from({ length: count }).map((_, i) => (
            <div
              key={i}
              className={`grid min-h-[86px] content-start gap-2 rounded-xl border border-zinc-100 px-3 py-2.5 ${
                count % 2 === 1 && i === count - 1
                  ? 'col-span-2 min-h-[64px]'
                  : ''
              }`}
            >
              <Bar className="h-2.5 w-20" />
              <Bar className="h-4 w-28" />
              <span className="block h-2.5 w-24 rounded-xl bg-zinc-100" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export function FieldsSkeleton({ rows = 8 }) {
  return (
    <div className="grid gap-4 px-3.5 py-4">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="grid gap-2 border-b border-zinc-100 pb-3">
          <span className="block h-2.5 w-24 rounded-xl bg-zinc-100" />
          <Bar className={`h-4 ${i % 3 === 0 ? 'w-2/3' : 'w-1/2'}`} />
        </div>
      ))}
    </div>
  );
}

export function CalendarSkeleton() {
  return (
    <div className="flex flex-col gap-[3px]" aria-hidden>
      {Array.from({ length: 12 }).map((_, m) => (
        <div key={m} className="flex items-center gap-[2px]">
          <span className="h-2.5 w-[30px] shrink-0" />
          {Array.from({ length: 31 }).map((__, d) => (
            <span
              key={d}
              className="h-[13px] min-w-0 flex-1 animate-pulse rounded-[3px] bg-zinc-100"
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function ModalRowsSkeleton({ rows = 6 }) {
  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-4 px-5 py-5">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-2.5">
          <span className="block h-2.5 w-20 rounded-xl bg-zinc-100" />
          <Bar className="h-3.5 w-24" />
        </div>
      ))}
    </div>
  );
}
